"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserRoutePermissions = void 0;
const react_1 = __importDefault(require("react"));
const routes_1 = require("./routes");
const feature_flags_1 = require("../feature-flags");
const hooks_1 = require("../hooks");
const State = __importStar(require("../store/state"));
// eslint-disable-next-line import/prefer-default-export
const useUserRoutePermissions = () => {
    const client = (0, hooks_1.useEnrichClient)();
    const getRoleFromRoles = (roles) => (roles.includes(State.UserRole.Admin)
        ? State.UserRole.Admin
        : roles.includes(State.UserRole.Merchandiser)
            ? State.UserRole.Merchandiser
            : null);
    const getUserRole = react_1.default.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { roles, licensed } = yield client.identity.getMyIdentity();
        if (licensed)
            return getRoleFromRoles(roles);
        return State.UserRole.Unlicensed;
    }), [client]);
    const getDrawerRoutes = (featureFlagsService) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const isEnrichAIEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.EnrichAI);
        const enrichDrawerRoutes = (0, routes_1.getEnrichDrawerRoutes)();
        const routeAllowList = {
            [State.UserRole.Admin]: [],
            [State.UserRole.Merchandiser]: [],
        };
        if (isEnrichAIEnabled) {
            routeAllowList[State.UserRole.Admin].push(enrichDrawerRoutes.ai);
            routeAllowList[State.UserRole.Merchandiser].push(enrichDrawerRoutes.ai);
        }
        try {
            const { roles, licensed } = yield client.identity.getMyIdentity();
            const role = getRoleFromRoles(roles);
            if (licensed) {
                routeAllowList[State.UserRole.Admin].unshift(...[enrichDrawerRoutes.editor, enrichDrawerRoutes.viewer]);
                routeAllowList[State.UserRole.Merchandiser].unshift(enrichDrawerRoutes.viewer);
            }
            if (licensed || isEnrichAIEnabled) {
                // currently only have one category and two routes
                // as the enrich application grows, this logic will change
                return [
                    {
                        label: 'MANAGE_PRODUCTS',
                        routes: (_a = routeAllowList[role]) !== null && _a !== void 0 ? _a : [],
                    },
                ];
            }
            return [];
        }
        catch (e) {
            return [];
        }
    });
    return { getDrawerRoutes, getUserRole };
};
exports.useUserRoutePermissions = useUserRoutePermissions;
